/**
 * Document Attachment Component
 * Displays document attachments as download cards
 */

import type { MessageAttachment } from '@/types/api.types';
import { formatFileSize, getFileIcon } from '@/utils/file-validation.util';
import { getAttachmentUrl } from '@/services/attachments.service';

interface DocumentAttachmentProps {
  attachment: MessageAttachment;
}

const DocumentAttachment = ({ attachment }: DocumentAttachmentProps) => {
  const downloadUrl = getAttachmentUrl(attachment.id);

  return (
    <a
      href={downloadUrl}
      download={attachment.file_name}
      className="flex items-center space-x-3 p-3 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200 transition-colors max-w-sm"
    >
      <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-white rounded-lg border border-gray-200">
        <span className="text-2xl">{getFileIcon(attachment.file_name)}</span>
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 truncate">
          {attachment.file_name}
        </p>
        <p className="text-xs text-gray-500">
          {attachment.file_size ? formatFileSize(attachment.file_size) : 'Файл'}
        </p>
      </div>

      <svg
        className="w-5 h-5 text-gray-400 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        />
      </svg>
    </a>
  );
};

export default DocumentAttachment;
